export type StateLookup = {
  name: string
  abbr: string
}
const STATES: StateLookup[] = [
  {
    name: 'Alberta',
    abbr: 'AB',
  },
  {
    name: 'British Columbia',
    abbr: 'BC',
  },
  {
    name: 'Manitoba',
    abbr: 'MB',
  },
  {
    name: 'New Brunswick',
    abbr: 'NB',
  },
  {
    name: 'Newfoundland and Labrador',
    abbr: 'NL',
  },
  {
    name: 'Northwest Territories',
    abbr: 'NT',
  },
  {
    name: 'Nova Scotia',
    abbr: 'NS',
  },
  {
    name: 'Nunavut',
    abbr: 'NU',
  },
  {
    name: 'Ontario',
    abbr: 'ON',
  },
  {
    name: 'Prince Edward Island',
    abbr: 'PE',
  },
  {
    name: 'Quebec',
    abbr: 'QC',
  },
  {
    name: 'Saskatchewan',
    abbr: 'SK',
  },
  {
    name: 'Yukon',
    abbr: 'YT',
  },
]

/**
 * Gets a two-letter state code by name.
 * @returns UPPERCASE state abbr., if found.
 * @param state State name to get abbreviation for
 */
function stateAbbrByName(state = '') {
  state = state.toLowerCase()
  const matchingState = STATES.find((obj) => obj.name.toLowerCase() === state)
  if (matchingState) return matchingState.abbr
  return null
}

/**
 * Gets a state name by two-letter abbreviation.
 * @returns Title Case state name, if found.
 * @param state State abbreviation to get name for
 */
function stateNameByAbbr(abbr = '') {
  abbr = abbr.toLowerCase()
  const matchingState = STATES.find((obj) => obj.abbr.toLowerCase() === abbr)
  if (matchingState) return matchingState.name
  return null
}

const abbrIsRapidCash = (abbr = '') =>
  ['wa', 'or', 'nv'].includes(abbr.toLowerCase())
const isRapidCash = (state = '') =>
  ['washington', 'oregon', 'nevada'].includes(state.toLowerCase())

const toTitleCase = function (sentence: string) {
  const smallWords =
    /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|v.?|vs.?|via)$/i
  const alphanumericPattern = /([A-Za-z0-9\u00C0-\u00FF])/
  const wordSeparators = /([ :–—-])/

  return sentence
    .split(wordSeparators)
    .map(function (current, index, array) {
      if (
        /* Check for small words */
        current.search(smallWords) > -1 &&
        /* Skip first and last word */
        index !== 0 &&
        index !== array.length - 1 &&
        /* Ignore title end and subtitle start */
        array[index - 3] !== ':' &&
        array[index + 1] !== ':' &&
        /* Ignore small words that start a hyphenated phrase */
        (array[index + 1] !== '-' ||
          (array[index - 1] === '-' && array[index + 1] === '-'))
      ) {
        return current.toLowerCase()
      }

      /* Ignore intentional capitalization */
      if (current.substr(1).search(/[A-Z]|\../) > -1) {
        return current
      }

      /* Ignore URLs */
      if (array[index + 1] === ':' && array[index + 2] !== '') {
        return current
      }

      /* Capitalize the first letter */
      return current.replace(alphanumericPattern, function (match) {
        return match.toUpperCase()
      })
    })
    .join('')
}

export {
  STATES,
  stateAbbrByName,
  stateNameByAbbr,
  abbrIsRapidCash,
  isRapidCash,
  toTitleCase,
}
